<template>
  <div
    class="drag-and-drop-wrapper"
    :class="{ 'is-dragging': isDragging }"
    @drop.prevent="handleDrop"
    @dragover.prevent="handleDragOver"
    @dragleave="handleDragLeave"
  >
    <upload-icon-grey />
    <p class="drag-drop-text">
      Drag & Drop Image Here
      <br> or
    </p>
    <button
      class="browse-images-btn other-image-browse"
      @click="handleBrowseImage"
    >
      <add-photo-icon color="#fff" />
      <span class="text">
        Browse Image
      </span>
    </button>
  </div>
</template>

<script>
import AddPhotoIcon from '@/@core/assets/svg-components/AddPhotoIcon.vue'
import UploadIconGrey from '@/@core/assets/svg-components/UploadIconGrey.vue'

export default {
  name: 'DragAndDrop',
  components: {
    UploadIconGrey,
    AddPhotoIcon,
  },
  data() {
    return {
      isDragging: false,
    }
  },
  methods: {
    handleDrop(event) {
      this.$emit('drop', event.dataTransfer.files)
      this.isDragging = false
    },
    handleDragOver() {
      this.isDragging = true
    },
    handleDragLeave() {
      this.isDragging = false
    },
    handleBrowseImage() {
      this.$emit('browse-image')
    },
  },
}
</script>
<style lang="scss">
.drag-and-drop-wrapper {
  margin-top: 8px;
  border: 1px dashed #D8D6DD;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 178px;
  border-radius: 4px;
  gap: 8px;

  .drag-drop-text {
    color: #90A0B7;
    font-size: 10px;
    line-height: 12px;
    text-align: center;
    margin-bottom: 0;
  }
}
.is-dragging {
  background-color: #cff0db;
}

.other-image-browse {
  padding: 4px 6px !important;
  background-color: #90A0B7 !important;
  border: none !important;
  span.text {
    color: #fff !important;
  }
}
</style>
